import { useTranslation } from 'react-i18next';
import { BliksLoader } from '@bliks-io/ui';

export function RoutePendingLoader() {
  const { t } = useTranslation();
  return (
    <div className="flex h-full items-center justify-center">
      <BliksLoader label={t('common.loading')} />
    </div>
  );
}
